import { useRouter } from "next/router";
import { pageName } from "lib/utils/events_utils";
import ProductCard from "components/common/ProductCard";
import { educationLoanData } from "constant";
import { trackClick } from "scripts/segment";
import { flowTypes } from "components/Login/LoginConstants";
import { ctaText } from "lib/utils/constants";

const OurProducts = ({ user, initLogin, features }) => {
  const router = useRouter();

  const handleCtaClick = (product) => {
    if (user) {
      const clickId = product === flowTypes.INSCHOOL ? "46" : "47";
      router.push(`/applications?clickId=${clickId}`);
    } else {
      trackClick(pageName.HOME_PAGE, {
        widgetName: "Our Products",
        widgetFormat: "Banner",
        contentName:
          product === flowTypes.INSCHOOL
            ? "Get Loan Offer"
            : "Get US Bank Account",
        contentFormat: "Button",
      });
      initLogin(true, "", product);
    }
  };

  return (
    <div className="bg-blue-950">
      <div className="max-w-page-width mx-auto px-4 py-12 md:py-24">
        <p className="text-22 md:text-5xl text-white font-bold pt-4">
          Why LeapFinance is right for you
        </p>
        <p className="text-sm md:text-lg text-white py-5">
          At LeapFinance, our goal is to empower your finances so you can study
          care-free.
        </p>
        <div className="py-4">
          <ProductCard
            productData={{ ...educationLoanData, features }}
            primaryCtaText={ctaText.START_MY_APPLICATION}
            primaryCtaHandler={() => {
              handleCtaClick(flowTypes.INSCHOOL);
            }}
            secondaryCtaText="Learn More"
            secondaryCtaHandler={() => {
              router.push("/loan-features/usa?clickId=48");
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default OurProducts;
